import { MULTI_SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config';

export const multiSelectSupportedTypes = [MULTI_SELECT_CF_TYPE];
